import { render } from "./SearchComponent.vue?vue&type=template&id=a9d99c2c&ts=true"
import script from "./SearchComponent.vue?vue&type=script&lang=ts"
export * from "./SearchComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__